import { IMetricCode } from "./IMetricCode";

export interface IPortfolioCompanyMetric {
    mnemonic:string,
    metricCode:string,
    /**
     * @format date
     */
    periodEndDate:Date,
    source:MetricSource,
    value: number | string

    metric?: IMetricCode
  }

export enum MetricSource {
  QUILT  = 'Quilt',
  DEALTEAM = 'DealTeam',
  Q360 = 'Q360'
 }